import { useNavigate } from '@tanstack/react-router';

import RegistrationSuccess from '@/components/organism/Registration/RegistrationSuccess';
import { clearRegistrationStep, clearRegistrationToken } from '@/utils/sessionStorage';

export const RegistrationSuccessPage = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    clearRegistrationStep();
    clearRegistrationToken();
    void navigate({ to: '/login' });
  };

  return <RegistrationSuccess onContinue={handleContinue} />;
};
